export default "__VITE_ASSET__CYKRUgTL__"